
<mat-toolbar class="header">
  <div class="back" mat-dialog-close matTooltip="Atrás" matTooltipPosition="right">
    <mat-icon >arrow_back_ios_new</mat-icon>
  </div>
  <div>
    {{ title }}
  </div>
  <div class="expander"></div>
  <button mat-button [mat-menu-trigger-for]="menu"><mat-icon>more_horiz</mat-icon></button>
  <mat-menu #menu="matMenu">
    @if (invoice()?.url) {
      <a mat-menu-item href="{{invoice().url}}" target="_blank">
        <mat-icon>download</mat-icon> Descargar Documento
      </a>
    }
    @if (isSale && (canSendToValidation | async)) {
      <button mat-menu-item (click)="validateInvoice()">
        <mat-icon>send</mat-icon>{{invoice()?.validated_at ? 'Reenviar a Validación': 'Enviar a Validación'}}
      </button>
    }
    @if (isSale && (canCancel | async)) {
      <button mat-menu-item (click)="cancelInvoice()">
        <mat-icon>cancel</mat-icon>Anular
      </button>
    }
  </mat-menu>
</mat-toolbar>

<div class="dialog-wrapper">
  @if(loading()) {
    <mat-spinner></mat-spinner>
  } @else {
    <div class="status-chips">
      @if (invoice()?.cancelled_at) {
        <app-chip 
          color="red"
          class="cursor-pointer"
          go-to-details
          [element]="{type: 'Invoice::Sale', id: invoice().data['annulment']['internal_document_id']}"
          text="Anulado por {{ 'debit_note' | human }} Nº {{ invoice().data['annulment']['internal_document_correlative_id'] }}"
          matTooltip="Anulado el {{invoice().cancelled_at | date}}"></app-chip>
      } @else {
        <app-chip [color]="invoice()?.status?.color" [text]="invoice()?.status?.name"></app-chip>
        <app-chip [color]="invoice()?.validated_at ? 'green' : 'red'"
                  [text]="invoice()?.validated_at ? 'Validado' : 'Sin validar'">
        </app-chip>
      }
    </div>
    <div class="info">
      <div class="name">Creación</div>
      <div class="value">{{invoice().created_at | date}}</div>

      @if (invoice().completed_at) {
        <div class="name">Finalización</div>
        <div class="value">{{invoice().completed_at | date}}</div>
      }
    </div>

    <div class="info">
      @if (isDebitNote) {
        <div class="name">Anula</div>
        <div class="value">{{invoice().document.sti_type | human}} Nº {{invoice().document.correlative_id}}</div>
      } @else {
        @if (invoice()?.due_date) {
          <div class="name">Fecha de Pago</div>
          <div class="value">{{invoice().due_date | date}}</div>
        }
        @if (invoice()?.payment_method) {
          <div class="name">Método de Pago</div>
          <div class="value">{{ invoice().payment_method | human }}</div>
        }
        @if (invoice()?.data?.payment?.receipt_number) {
          <div class="name">Número Comprobante</div>
          <div class="value">{{ invoice().data.payment.receipt_number }}</div>
        }
        @if (invoice()?.data?.payment?.amount) {
          <div class="name">Monto {{ alreadyPayed ? 'Pagado' : 'a Pagar' }}</div>
          <div class="value">{{ invoice().data.payment.amount | money }}</div>
        }
      }
    </div>

    @if (invoice().url) {
      <div class="pdf-viewer">
        @if (isMobile()) {
          <iframe [src]="invoice().url | safe" type="application/pdf" class="iframe"></iframe>
        } @else {
          @if (loadingPdf()) {
            <div class="skeleton pdf-skeleton"></div>
          }
          <object [data]="invoice().url | safe" type="application/pdf" (load)="pdfLoaded()"></object>
        }

      </div>
    }
    @if ((invoice()?.works?.length || 0) > 0) {
      <div class="works-container">
        <app-document-works [order]="invoice()" (load)="reloadInvoice()" [modalComponent]="true"></app-document-works>
      </div>
    }
  }
</div>

@if (!loading()) {
  <mat-toolbar class="footer">
    @if (invoice().document_id) {
      <div class="document-button-container">
        <button
          mat-button
          go-to-details
          [element]="invoice().document"
          mode="modal"
          class="primary"
        >
          Ver {{invoice().document.sti_type || invoice().document.type | human}} #{{invoice().document.correlative_id}}
        </button>
      </div>
    }
  
    <div class="expander"></div>
    @if(invoice().status_id) {
      <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">
        <i class="fa fa-pencil-alt"></i>
        <span class="hide-mobile">{{invoice().status_id | status: 'name': statuses()}}</span>
      </button>
    }
    <mat-menu #menu="matMenu">
      @for (status of statuses(); track status.id) {
        <button
          mat-menu-item
          (click)="setStatus(status.id)"
          [style.color]="status.color"
          [disabled]="status.id === invoice()?.status_id"
          matTooltip="Estado actual"
          [matTooltipDisabled]="status.id !== invoice()?.status_id"
        >
          <span>{{status.name}}</span>
          @if (status.id === invoice()?.status_id) {
            &nbsp;
            <div class="fa fa-check"></div>
          }
        </button>
      }
    </mat-menu>
  </mat-toolbar>
}
